<template>
  <div class="adput-group">
    <div class="panel-header">
      <h3 class="panel-header__title">广告组管理</h3>
      <span class="panel-header__subtitle">AD GROUP MANAGEMENT</span>
      <a class="panel-header__export" v-if="exportUrl" :href="exportUrl">导出</a>
    </div>
    <div class="panel-content">
      <h3 class="panel-content__title">
        广告组管理
        <up-button type="primary" class="fr" @click="operateGroup('add')">新增广告组</up-button>
      </h3>
      <div class="panel-content__select-list">
        <up-select class="mr5 is-small" v-model="key" :data="selectList" @up:select:change="handleChange"></up-select>
        <up-input class="mr5" v-model="value"></up-input>
        <up-button type="primary" @click="searchGroup()">查询</up-button>
        <up-tag closable type="info" size="medium" class="panel-content__tag ml20" v-if="isTagShow" @close="handleClose" :disable-transitions="true"><span>已筛选的广告组名称包含: {{adGroupName}}</span></up-tag>
        <div class="fr mr20">
          <up-button type="primary" @click="batchStartAndStopGroup(selectedIds, true, true)">批量开启</up-button>
          <up-button class="is-warning" type="primary" @click="batchStartAndStopGroup(selectedIds, true, false)">批量暂停</up-button>
        </div>
      </div>
      <div class="panel-content__table-wrap">
        <up-table :page="page" :widthColumns="{ id: 200, order_name: 200, name: 160, budget_msg: 108, created_at: 160 }" :slotContents="['order_name', 'jump_type']" show-overflow-tooltip selection pagination @up:selection-change="handleUpSelectChange" align="center" @up:current-change="({ currentPage }) => searchGroup(currentPage)" @up:size-change="searchGroup()">
          <template slot="order_name:content" slot-scope="{ row }">
            <router-link class="panel-content__table-link" :to="{ path: '/plans', query: { name: row.order_name, value: 'order_name' } }">{{ row.order_name }}</router-link>
          </template>
          <template slot="jump_type:content" slot-scope="{ row }">
            {{jumpTypesMap[row.jump_type]}}
          </template>
          <template slot="up:operate">
            <up-table-column width="54" fixed="right" label="开关">
              <template slot-scope="{ row, $index }">
                <up-switch v-if="row.status !== 2" :value="row.status === 1" @change="startAndStopGroup(row, $index)"></up-switch>
              </template>
            </up-table-column>
            <up-table-column width="250" fixed="right" label="操作">
              <template slot-scope="{ row }">
                <!--<template v-if="row.is_delete !== 1 || row.status !== 2">
                  <up-tooltip effect="dark" placement="top" content="编辑" v-if="row.status === 0">
                    <i class="panel-content__table-icon iconfont icon-edit" @click="operateGroup('edit', row)"></i>
                  </up-tooltip>
                  <up-tooltip effect="dark" placement="top" :content="row.status === 0 ? '开启' : '暂停'">
                    <span>
                      <i v-show="!loadings[$index]" class="panel-content__table-icon iconfont" :class="row.status === 0 ? 'icon-play' : 'icon-pause'" @click="startAndStopGroup(row, $index)"></i>
                      <i v-show="loadings[$index]" class="panel-content__table-icon el-icon el-icon-loading"></i>
                    </span>
                  </up-tooltip>
                  <up-tooltip effect="dark" placement="top" content="停止">
                    <i class="panel-content__table-icon iconfont icon-stop" @click="removeGroup(row)"></i>
                  </up-tooltip>
                </template>
                <up-tooltip effect="dark" placement="top" content="查看">
                  <i class="panel-content__table-icon iconfont icon-look" @click="operateGroup('view', row)"></i>
                </up-tooltip>
                <up-tooltip effect="dark" placement="top" content="复制">
                  <i class="panel-content__table-icon iconfont icon-fuzhi" @click="operateGroup('copy', row)"></i>
                </up-tooltip>-->
                <up-button v-if="row.status === 0" class="is-edit" size="small" type="primary" @click="operateGroup('edit', row)">编辑</up-button>
                <up-button class="is-view" size="small" type="primary" @click="operateGroup('view', row)">查看</up-button>
                <!--<up-button class="is-mini" size="small" type="primary" @click="startAndStopGroup(row)">开始</up-button>-->
                <up-button v-if="row.status !== 2" class="is-remove" size="small" type="primary" @click="removeGroup(row)">停止</up-button>
                <up-button class="is-mini" size="small" type="primary" @click="operateGroup('copy', row)">复制</up-button>
              </template>
            </up-table-column>
          </template>
        </up-table>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
// import { capturedGet, capturedPost, capturedRemove } from '@/agent/http'
import { BASE_URL } from '@/global/util/constants'
import { mapActions } from 'vuex'

/**
 * is_delete: 0 可编辑, 1 不可编辑
 * status: 0 暂停中, 1 投放中, 2 已停止
 * verify: 0 待审核, 1 已审核, 2 已拒绝
 */
export default {
  name: 'group',
  data () {
    this.jumpTypesMap = {}

    return {
      platform: '',
      selectList: [],
      statusList: [],
      key: '',
      value: '',
      isTagShow: false,
      adGroupName: '',
      page: new this.$page(),
      selectedIds: [],
      starting: false,
      stopping: false,
      loadings: []
    }
  },
  computed: {
    exportUrl () {
      const params = { page: 1, count: 5000 }
      if (this.key && this.value) {
        params[this.key] = this.value
      }
      return BASE_URL + `/${this.platform}/global-order/export?` + qs.stringify(params)
    }
  },
  methods: {
    ...mapActions([
      'group/removeGroup',
      'group/batchStartAndStopGroup',
      'group/getGroups',
      'group/getSelectData',
      'group/getJumpTypes'
    ]),
    // 新增广告组
    operateGroup (type, row) {
      this.$router.push(`/group/${type}${type !== 'add' ? '/' + row.id : ''}`)
    },
    handleChange () { // 清空输入框
      this.value = ''
    },
    // 查询广告组
    searchGroup (currentPage = 1) {
      this.page.currentPage = currentPage
      this.isTagShow = false
      if (this.key && this.value) {
        this.getGroups({ [this.key]: this.value })
      } else {
        this.getGroups()
      }
    },
    startAndStopGroup (row, index) {
      this.batchStartAndStopGroup([row.id], false, row.status === 0, index)
    },
    // 停止广告组
    async removeGroup (row) {
      this.$msgbox({
        title: '温馨提示',
        message: `确定要删除ID为 “${row.id}” 的广告组吗？`,
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = '执行中...';
            const [err, res] = await this['group/removeGroup']({ platform: this.platform, id: row.id })
            instance.confirmButtonLoading = false;
            if (err || res.code !== 1) this.$message.error('删除广告组失败')
            else if (res.code === 1) this.$message.success('删除广告组成功')
          }
          if (instance.confirmButtonLoading) instance.confirmButtonLoading = false;
          done()
        }
      }).then(_ => {
        this.getGroups()
      })
    },
    handleUpSelectChange ({ selection, selectAll }) {
      this.selectedIds = selection.map(v => v.id)
    },
    // 批量开启/暂停广告组
    async batchStartAndStopGroup (ids, batch, isStart, index) {
      let text = isStart ? '开启' : '暂停'
      const status = isStart ? 'starting' : 'stopping'
      if (batch) {
        if (!ids.length) {
          return this.$message.error(`你还没有选中要批量${isStart ? '开启' : '暂停'}的广告组`)
        }

        this[status] = true
        text = '批量' + text
      } else {
        this.loadings.splice(index, 1, true)
      }

      const [err, res] = await this['group/batchStartAndStopGroup']({ platform: this.platform, isStart, ids })
      if (batch) {
        this[status] = false
      } else {
        this.loadings.splice(index, 1, false)
      }
      if (err || res.code !== 1) this.$message.error(`${text}广告组失败`)
      else {
        this.$message.success(`${text}广告组成功`)
        this.getGroups()
      }
    },
    async getGroups (params = {}) {
      const { pageSize, currentPage } = this.page
      this.page.loading = true
      const [, { data: { header, data: { data, total } } }] = await this['group/getGroups']({
        platform: this.platform,
        params: {
          per_page: pageSize,
          page: currentPage,
          ...params
        }
      })
      this.page.setData({ header, data, total })
      this.loadings = Array.from({ length: data.length }, Boolean)
    },
    async getSelectData () {
      const [, { data: { arr1: selectList, status: statusList } }] = await this['group/getSelectData']({ platform: this.platform })
      this.selectList = selectList
      this.statusList = statusList
    },
    async getJumpTypes () {
      const [, { data = [] }] = await this['group/getJumpTypes']()
      this.jumpTypesMap = data.reduce((prev, cur) => {
        prev[cur.value] = cur.name
        return prev
      }, {});
    },
    handleClose () {
      this.isTagShow = false
      this.adGroupName = ''
      this.key = ''
      this.value = ''
      this.$router.replace('/groups')
      this.getGroups()
    }
  },
  created () {
    this.platform = this.$route.meta.platform
    this.getSelectData()
    this.getJumpTypes()

    const { name, value } = this.$route.query
    if (name && value) {
      this.key = value
      this.value = name
      if (value === 'order_name') {
        this.isTagShow = true
        this.adGroupName = name
      }
      this.getGroups({ [value]: name })
    } else {
      this.getGroups()
    }
  }
}
</script>

<style lang="scss">
@include b(adput-group) {
  //body
}
</style>
